import { render, staticRenderFns } from "./audioPreview.vue?vue&type=template&id=064b1c28&scoped=true&"
import script from "./audioPreview.vue?vue&type=script&lang=js&"
export * from "./audioPreview.vue?vue&type=script&lang=js&"
import style0 from "./audioPreview.vue?vue&type=style&index=0&id=064b1c28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b1c28",
  null
  
)

export default component.exports